module.exports = __webpack_public_path__ + "img/chd-vendee.aa1669a1.png";